import { render, staticRenderFns } from "./AssetIssuanceRowStatus.vue?vue&type=template&id=821a5570"
import script from "./AssetIssuanceRowStatus.vue?vue&type=script&lang=js"
export * from "./AssetIssuanceRowStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports